import mapboxgl, { GeoJSONSource } from "mapbox-gl";
import { store } from "../../store";
import { api } from "../common/make_api";

import { ReserveTripMapRequest } from "../../api/models/ReserveTripMapRequest";
import {
    ReserveTripMapState,
    reserveTripMapSlice,
} from "../../features/Reserve/store";
import {
    ActionType,
    ResourceType,
    StatusType,
    sendLog,
} from "../../services/common/send_log";
import { loadIcons } from "../map/icons";
import { addLayersIfNotExist } from "../map/layers/generics";
import { makeMap } from "../map/map";
import { mapObjects } from "./map_objects";

export async function retrieve(param: ReserveTripMapRequest) {
    try {
        const reserveTripMap = await api.getReserveApi().getReserveTripMap({
            reserveTripMapRequest: param,
        });
        const state = {
            isValid: true,
            res: reserveTripMap,
        } as ReserveTripMapState;
        store.dispatch(reserveTripMapSlice.actions.updateMap(state));
        sendLog(
            ResourceType.TRIPS_MAP,
            StatusType.GET_RESOURCE,
            ActionType.TRIPS_MAP_MONITORING
        );
    } catch (e) {
        // 4xx or 5xx エラー
        // TODO 4xx と 5xx でメッセージを変える
        store.dispatch(reserveTripMapSlice.actions.resetState());
    }
}

export const initMap = (mapContainerName: string): mapboxgl.Map => {
    const featuresMap = new Map<string, any>();
    for (const obj of _mapObjects) {
        obj.buildFeatures(featuresMap);
    }

    // 地図中心位置とズームは地図作成時に指定する
    let map: mapboxgl.Map;
    const usl = featuresMap.get("unladen_start_loc");
    if (usl) {
        const loc = usl.geometry.coordinates;
        map = makeMap(mapContainerName, 13, loc);
    } else {
        map = makeMap(mapContainerName);
    }

    for (const obj of _mapObjects) {
        obj.setEventListener(map);
    }
    loadIcons(map);

    map.on("load", () => {
        registerMapObject(map);
        for (const [k, v] of featuresMap.entries()) {
            (map.getSource(k) as GeoJSONSource).setData(v);
        }
    });

    map.on("mouseover", () => {
        map.getCanvas().style.cursor = "initial";
    });
    map.on("mouseleave", () => {
        map.getCanvas().style.cursor = "";
    });

    return map;
};

const _mapObjects = mapObjects();

function registerMapObject(map: mapboxgl.Map) {
    for (const obj of _mapObjects) {
        if (map.getSource(obj.sourceName)) {
            // あり得ないケース
            console.error(
                "Duplicate calling: addSource() sorceName=",
                obj.sourceName
            );
            continue;
        }
        // MEMO addSourceの段階でmap loadが終わっていないといけない
        map.addSource(obj.sourceName, {
            type: "geojson",
            data: {
                type: "FeatureCollection",
                features: [],
            },
            generateId: true,
            promoteId: "id",
        });
    }

    let layers: Array<mapboxgl.Layer> = new Array();
    for (const obj of _mapObjects) {
        layers = layers.concat(obj.layers);
    }
    addLayersIfNotExist(map, layers);
}
